import styles from "../index.module.css";
import a from "../../../assets/images/icons/arrow-down.svg";
import React, { useState } from "react";
const data = [
  {
    titile: "HR менеджер по международным стандартам.",
    body: "Рыбатекст используется дизайнерами, проектировщиками и фронтендерами, когда нужно быстро заполнить макеты или прототипы содержимым. Это тестовый контент, который не должен нести никакого смысла, лишь показать наличие самого текста или продемонстрировать типографику в деле. ",
  },
  {
    titile: "HR менеджер по международным стандартам.",
    body: "Рыбатекст используется дизайнерами, проектировщиками и фронтендерами, когда нужно быстро заполнить макеты или прототипы содержимым. Это тестовый контент, который не должен нести никакого смысла, лишь показать наличие самого текста или продемонстрировать типографику в деле. ",
  },
  {
    titile: "HR менеджер по международным стандартам.",
    body: "Рыбатекст используется дизайнерами, проектировщиками и фронтендерами, когда нужно быстро заполнить макеты или прототипы содержимым. Это тестовый контент, который не должен нести никакого смысла, лишь показать наличие самого текста или продемонстрировать типографику в деле. ",
  },
  {
    titile: "HR менеджер по международным стандартам.",
    body: "Рыбатекст используется дизайнерами, проектировщиками и фронтендерами, когда нужно быстро заполнить макеты или прототипы содержимым. Это тестовый контент, который не должен нести никакого смысла, лишь показать наличие самого текста или продемонстрировать типографику в деле. ",
  },
  {
    titile: "HR менеджер по международным стандартам.",
    body: "Рыбатекст используется дизайнерами, проектировщиками и фронтендерами, когда нужно быстро заполнить макеты или прототипы содержимым. Это тестовый контент, который не должен нести никакого смысла, лишь показать наличие самого текста или продемонстрировать типографику в деле. ",
  },
  {
    titile: "HR менеджер по международным стандартам.",
    body: "Рыбатекст используется дизайнерами, проектировщиками и фронтендерами, когда нужно быстро заполнить макеты или прототипы содержимым. Это тестовый контент, который не должен нести никакого смысла, лишь показать наличие самого текста или продемонстрировать типографику в деле. ",
  },
];
const Regulations = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const open = (item) => {
    if (selectedItem === item) {
      setSelectedItem(null);
      return;
    }
    setSelectedItem(item);
  };
  return (
    <div className={styles.app}>
      <div className={styles.wrap}>
        <div className={styles.left}>
          {data.slice(0, Math.floor(data.length/2)).map((item, index) => (
            <div className={styles.card}>
              <div className={styles.head} onClick={() => open(item)}>
                <h1>{item.titile}</h1>
                <img className={selectedItem === item && styles.rotate} src={a} alt="" />
              </div>
              <h2 className={selectedItem === item ? styles.visible : styles.body}>
                {item.body}
              </h2>
            </div>
          ))}
        </div>

        <div className={styles.right}>
          {data.slice(Math.floor(data.length/2)).map((item, index) => (
            <div className={styles.card}>
              <div className={styles.head} onClick={() => open(item)}>
                <h1>{item.titile}</h1>
                <img className={selectedItem === item && styles.rotate} src={a} alt="" />
              </div>
              <h2 className={selectedItem === item ? styles.visible : styles.body}>
                {item.body}
              </h2>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Regulations;
